import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Slide
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Autocomplete from '@material-ui/lab/Autocomplete';
import styles from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";
import { makeStyles } from "@material-ui/core/styles";
import { wsGet } from "services/WService.js";
import { WithApp } from "contexts/appContext";
import useItemChanges from "hooks/useItemChanges";
import Modal from 'components/Tvendo/Common/ModalBase';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default WithApp(function ContactModal(props) {
  const classes = useStyles();
  const contacto = props.model;
  const contactId = props.contactId;

  const [contact, setContact] = useState({});
  const [contactLoaded, setContactLoaded] = useState({});
  const [zone, setZones] = useState([]);
  const itemChanges = useItemChanges(contactLoaded, contact);

  async function getZones() {
    const response = await wsGet("base/zone");
    if (response.success) {
      setZones(response.data);
    }
  }

  const handleClose = () => {
    props.close(false);
  };

  const handleChange = (e) => {
    setContact({...contact,[e.target.name]: e.target.value});
  };

  const [dataChanging, setDataChanging] = useState(undefined);
  const handleChangeZone = (field, value) => {
    setDataChanging(prev => ({ ...prev, [field]: value }));
    setContact(prev => ({ ...prev, [field]: value }));
  };


  useEffect(() => {
    getZones();
  }, []);
  return (
    <>
      <Modal
        title={`Contactos`}
        model={contacto}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='base/business-partner-contact'
        dataForce={{base_business_partner_id: contactId,base_zone_id: dataChanging?.base_zone_id}}
      >
        <GridContainer>
          <GridItem>
            <TextField
              label="ID contacto"
              fullWidth
              name="Name"
              margin="normal"
              size="small"
              required
              // value={contacto.Name || ""}
              defaultValue={!!contacto ? contacto.Name : ''}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true
              }}
            />
            <TextField
              label="Primer Nombre"
              fullWidth
              name="FirstName"
              margin="normal"
              size="small"
              // value={contacto.FirstName || ""}
              defaultValue={!!contacto ? contacto.FirstName : ''}
              onChange={handleChange}
            />
            <TextField
              label="Segundo Nombre"
              fullWidth
              name="MiddleName"
              // value={contacto.MiddleName || ""}
              defaultValue={!!contacto ? contacto.MiddleName : ''}
              margin="normal"
              size="small"
              onChange={handleChange}
            />
            <TextField
              label="Apellidos"
              fullWidth
              name="LastName"
              // value={contacto.LastName || ""}
              defaultValue={!!contacto ? contacto.LastName : ''}
              margin="normal"
              size="small"
              required
              onChange={handleChange}
            />
            <TextField
              label="Fec. Nacimiento"
              fullWidth
              name="BirthDate"
              // value={contacto.BirthDate || ""}
              defaultValue={!!contacto ? contacto.BirthDate : ''}
              type="date"
              InputLabelProps={{
                shrink: true
              }}
              margin="normal"
              size="small"
              onChange={handleChange}
            />
            <TextField
              label="Lugar Nacimiento"
              fullWidth
              name="BirthCity"
              // value={contacto.BirthCity || ""}
              defaultValue={!!contacto ? contacto.BirthCity : ''}
              margin="normal"
              size="small"
              onChange={handleChange}
            />
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Género</InputLabel>
              <Select
                // value={contacto.Gender || ""}
                defaultValue={!!contacto ? contacto.Gender : ''}
                inputProps={{
                  name: "Gender",
                  onChange: handleChange
                }}
              >
                <MenuItem value="M">Masculino</MenuItem>
                <MenuItem value="F">Femenino</MenuItem>
              </Select>
            </FormControl>
          </GridItem>
          <GridItem>
            <Autocomplete
              disableClearable
              options={zone}
              getOptionLabel={(z) => z.description || ""}
              defaultValue={
                zone.find(
                  (z) => String(z.id) === String(contacto?.base_zone_id)
                ) || null
              }
              renderInput={(params) => (
                <TextField {...params} label="Zona" margin="normal" fullWidth />
              )}
              onChange={(e, selected) => {
                handleChangeZone("base_zone_id", selected?.id || null);
              }}
            />
            <TextField
              label="Dirección"
              fullWidth
              name="Address"
              // value={contacto.Address || ""}
              defaultValue={!!contacto ? contacto.Address : ''}
              margin="normal"
              size="small"
              onChange={handleChange}
            />
            <TextField
              label="Teléfono"
              fullWidth
              name="Tel1"
              // value={contacto.Tel1 || ""}
              defaultValue={!!contacto ? contacto.Tel1 : ''}
              type="number"
              margin="normal"
              size="small"
              max="5"
              onChange={handleChange}
            />
            <TextField
              label="Celular"
              fullWidth
              name="Cellolar"
              // value={contacto.Cellolar || ""}
              defaultValue={!!contacto ? contacto.Cellolar : ''}
              maxLength="9"
              margin="normal"
              size="small"
              inputProps={{ onChange: handleChange, maxLength: 9 }}
            />
            <TextField
              label="Correo"
              fullWidth
              name="E_MailL"
              // value={contacto.E_MailL || ""}
              defaultValue={!!contacto ? contacto.E_MailL : ''}
              type="email"
              margin="normal"
              size="small"
              required
              onChange={handleChange}
            />
            <TextField
              label="Profesión"
              fullWidth
              name="Profession"
              // value={contacto.Profession || ""}
              defaultValue={!!contacto ? contacto.Profession : ''}
              margin="normal"
              size="small"
              onChange={handleChange}
            />
            <TextField
              label="Notas"
              fullWidth
              name="Notes1"
              // value={contacto.Notes1 || ""}
              defaultValue={!!contacto ? contacto.Notes1 : ''}
              margin="normal"
              size="small"
              multiline
              inputProps={{ onChange: handleChange, minRows: 4 }}  
            />
          </GridItem>
        </GridContainer>
      </Modal>
    </>
  );
});
